import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'History|Continuing Education|';

export type CreqLoc =
	| 'CPContinuingEducationUnderReviewContent'
	| 'CPContinuingEducationInvalidContent'
	| 'CPContinuingEducationInvalidLabel'
	| 'CPContinuingEducationValidContent';

export const cpCreqLocs: LocDefs<CreqLoc> = {
	CPContinuingEducationUnderReviewContent: {
		defaultValue: 'Under Review',
		description: 'Content displayed when a Continuing Education requirement is under review.',
		displayPath: `${dpRoot}Under Review Content`,
		displayType: 'Content',
		feature: HubFeature.CredentialContinuingEducation,
		portal: 'CP',
	},
	CPContinuingEducationInvalidContent: {
		defaultValue: 'Invalid',
		description: 'Content displayed when a Continuing Education requirement is invalid.',
		displayPath: `${dpRoot}Invalid Content`,
		displayType: 'Content',
		feature: HubFeature.CredentialContinuingEducation,
		portal: 'CP',
	},
	CPContinuingEducationValidContent: {
		defaultValue: 'Valid',
		description: 'Content displayed when a Continuing Education requirement is valid.',
		displayPath: `${dpRoot}Valid Content`,
		displayType: 'Content',
		feature: HubFeature.CredentialContinuingEducation,
		portal: 'CP',
	},
	CPContinuingEducationInvalidLabel: {
		defaultValue: 'Invalid',
		description: 'Label for Continuing Education Invalid column.',
		displayPath: `${dpRoot}Invalid Label`,
		displayType: 'Label',
		feature: HubFeature.CredentialContinuingEducation,
		portal: 'CP',
	},
};

export const LOC_KEYS = MapLocKeys<CreqLoc>(cpCreqLocs);
